"use client"
import Link from "next/link"
import { Button } from "@/components/ui/button"
import DesktopFooter from "@/components/landing/desktop/DesktopFooter"
import DesktopNavbar from "@/components/elements/bars/DesktopNavbar"
import { ArrowLeft } from "lucide-react"

export default function NotFound() {
    return (
        <div className="min-h-screen flex flex-col">
            <DesktopNavbar />

            <main className="flex-1 flex flex-col items-center justify-center bg-skillsewa-primary text-white px-4 mb-2">
                {/* Animated 404 */}
                <div
                    // initial={{ y: -50, opacity: 0 }}
                    // animate={{ y: 0, opacity: 1 }}
                    // transition={{ type: "spring", stiffness: 120, damping: 10 }}
                    className="text-8xl font-bold mb-4"
                >
                    404
                </div>

                {/* Subtitle */}
                <p
                    // initial={{ opacity: 0 }}
                    // animate={{ opacity: 1 }}
                    // transition={{ delay: 0.3, duration: 0.6 }}
                    className="text-lg mb-8 text-center max-w-md"
                >
                    Oops! The page you’re looking for doesn’t exist.
                    It might have been moved or deleted.
                </p>

                {/* Home Button */}
                <div
                    // initial={{ scale: 0.8, opacity: 0 }}
                    // animate={{ scale: 1, opacity: 1 }}
                    // transition={{ delay: 0.6, type: "spring" }}
                >
                    <Link href="/">
                        <Button
                            className="rounded-xl px-6 py-3 bg-white text-skillsewa-primary font-semibold shadow-lg hover:scale-105 transition-transform hover:text-white"
                        >
                            <ArrowLeft /> Go Back Home
                        </Button>
                    </Link>
                </div>
            </main>

            <DesktopFooter />
        </div>
    )
}
